import "layouts/Home/HomeElements/Styles/Banner.css";
import React from "react";
import pagesStyle from "assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import {ExpandMore, OpenInNew, Pause, VolumeMute} from "@material-ui/icons"
import EventManager, {events} from '../../../utils/EventManager'
import VolumeUp from "@material-ui/icons/VolumeUp";
import {addHttpsToUrl, getActiveChannel, getStoredChannel} from "../../../api-client/core/authentication/utils";
import localization from '../../../config/localization';
import NoControlsYoutubeEmbed from "../../../components/Letflow/NoControlsYoutubeEmbed";

class DefaultBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      banner: this.props.banner,
      playingButton: false,
      previewEnded: false,
      showPreview: true,
      language: localStorage.getItem("default_language"),
    }
  }

  componentDidMount() {
    EventManager.getInstance().subscribe(events.OPEN_CONTENT_MODAL, this.pauseVideoWhenOpenModal)
    EventManager.getInstance().subscribe(events.CHANGE_VIDEO_SLIDER_BANNER, this.pauseVideoWhenOpenModal)
  }

  componentWillUnmount() {
    EventManager.getInstance().unsubscribe(events.OPEN_CONTENT_MODAL, this.pauseVideoWhenOpenModal)
    EventManager.getInstance().unsubscribe(events.CHANGE_VIDEO_SLIDER_BANNER, this.pauseVideoWhenOpenModal)
  }

  pauseVideoWhenOpenModal = () => {
    let isYoutube = !!this.state.banner.embed_url && this.state.banner.embed_url.length > 0;
    if (this.state.playingButton === true) {
      this.setState({ playingButton: false }, () => {
        if (isYoutube) {
          this._youtubePlayer && this._youtubePlayer.muteVideo();
          return;
        }
        let video = this.refs[`video-${this.state.banner.id}`]
        video.muted = true
        video.pause()
        document.removeEventListener('fullscreenchange', video.fullScreen);
        document.removeEventListener('webkitfullscreenchange', video.fullScreen);
        document.removeEventListener('mozfullscreenchange', video.fullScreen);
        document.removeEventListener('msfullscreenchange', video.fullScreen);
      })
    }
  }

  handleMouseOver = () => {
    let isYoutube = !!this.state.banner.embed_url && this.state.banner.embed_url.length > 0;
    if(this.state.showPreview && !isYoutube) {
      let {banner} = this.state
      banner.state = 'hover'
      this.setState({ banner: this.state.banner })
      this.playVideo(banner.preview ? 'preview' : 'video', banner.id);
    }
  }

  handleMouseOut = () => {
    let isYoutube = !!this.state.banner.embed_url && this.state.banner.embed_url.length > 0;
    if(this.state.showPreview && !isYoutube) {
      let {banner} = this.state;
      banner.state = 'none'
      this.setState({banner})
      this.pauseVideo(banner.preview ? 'preview' : 'video', banner.id)
    }
  }

  handleClickPlay = () => {
    let {banner} = this.state
    let isYoutube = !!banner.embed_url && banner.embed_url.length > 0;
    let video
    if (this.state.playingButton === true) {
      this.setState({ playingButton: false }, () => {
        if (isYoutube) {
          this._youtubePlayer && this._youtubePlayer.muteVideo();
          return;
        }
        video = this.refs[`video-${banner.id}`]
        video.muted = true
        video.pause()
      })
    } else {
      this.setState({ playingButton: true }, () => {
        if (isYoutube) {
          this._youtubePlayer && this._youtubePlayer.playVideo();
          return;
        }
        video = this.refs[`video-${banner.id}`]
        this.state.showPreview && video.load()
        video.play()
        video.muted = false
        this.setState({ showPreview: false })
        EventManager.getInstance().dispatch(events.BANNER_SOUND_ENABLED)
      })

    }
  }

  playVideo = (type, refName) => this.refs[`${type}-${refName}`].play()

  pauseVideo = (type, refName) => this.refs[`${type}-${refName}`].pause()

  setMouseMove = (e) => {
    e.preventDefault();
    this.setState({mouseMoving: true});

    let timeout;
    (() => {
      clearTimeout(timeout);
      timeout = setTimeout(() => this.setState({mouseMoving:false}), 10000);
    })();
  }

  getForLang = (translations, key) => {
    let {language} = this.state;
    let localTranslation = translations.find(t => t.lang == language);
    return localTranslation ? localTranslation[key] : null;
  } 

  render() {
    let { banner } = this.state;
    let bannerTitle = (banner.translations && banner.translations.length > 0 && this.getForLang(JSON.parse(banner.translations), 'title')) || banner.title;
    let bannerSubtitle = (banner.translations && banner.translations.length > 0 && this.getForLang(JSON.parse(banner.translations), 'subtitle')) || banner.subtitle;
    let isYoutube = !!banner.embed_url && banner.embed_url.length > 0;
    return (
      <React.Fragment>
        <div className={isYoutube ? "home-banner-video home-banner-youtube-video" : "home-banner-video"}>
          <div className="default-home-banner-cover" style={{zIndex: this.state.playingButton ? 0 : 12}}/>
          <ul className={"home-banner-ul"} style={{ height: "100%" }}>
            <div className="home-banner-item">
              {banner.link  &&
                <a href={addHttpsToUrl(banner.link)}
                   className="default-home-banner-link-button"
                   target={!!banner.new_tab && "_blank"}
                   style={{textDecoration: "none"}}
                >
                  <p style={{padding: "2px 7px"}}>{localization.get('go_to.link')}</p> <OpenInNew/>
                </a>
              }
              <div style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                overflow: "hidden",
                zIndex: banner.state === "hover" ? "10" : banner.state === "left" ? "9" : "8",
              }}>
                {isYoutube ? 
                  <NoControlsYoutubeEmbed
                    ref={(r) => this._youtubePlayer = r}
                    url={banner.embed_url}
                    index={banner.id}
                    currentIndex={banner.id}
                  />
                :
                banner.preview && !this.state.playingButton && this.state.showPreview ?
                  <video
                    id="banner-video"
                    muted={true}
                    ref={`preview-${banner.id}`}
                    loop={false}
                    preload={"auto"}
                    className={"default-home-banner-video"}
                    autoPlay={true}
                    style={{
                      zIndex: banner.state === "hover" ? "10" : "8",
                      minWidth: "100%",
                      minHeight: "100%",
                      left: "50%",
                      position: "absolute",
                      top: "50%",
                      transform: "translate(-50%, -50%)"
                    }}
                    controls={false}
                    playsInline={true}
                    src={banner.preview.url}
                  />
                  :
                  <video
                    id="banner-video"
                    muted={true}
                    ref={`video-${banner.id}`}
                    loop={false}
                    preload={"auto"}
                    className={"default-home-banner-video"}
                    autoPlay={false}
                    style={{
                      zIndex: banner.state === "hover" ? "10" : "8",
                      minWidth: "100%",
                      minHeight: "100%",
                      left: "50%",
                      position: "absolute",
                      top: "50%",
                      transform: "translate(-50%, -50%)"
                    }}
                    controls={false}
                    playsInline={true}
                    src={banner.video.url}
                  />
                }
                <div className={"over-home-banner-video"} style={{background: `linear-gradient(rgba(255, 255, 0, 0), ${getActiveChannel() ? getStoredChannel().preferences.interaction_color : '#0e0e0e'})`
                }}>
                  <ExpandMore
                    style={{transition: ".5s", marginTop: "20px", marginBottom: !this.state.showPreview ? -20 : 20, left: "calc(50% - 20px)" }}
                    className="arrow-down over-action"
                  />
                </div>
              </div>
              <li className="item-home-banner">
                <div
                  className="video-caption default-home-banner-video-container"
                  onMouseMove={e => this.setMouseMove(e)}
                  style={{left: 0, width: "100%"}}
                >
                  <div className="home-banner-video-title">
                    <div className="home-banner-video-title-content" style={{bottom: !this.state.showPreview ? 20 : "20%"}}>
                      <h3 className="home-banner-title ">{bannerTitle}</h3>
                      <h5 className="home-banner-subtitle mb15 mt0">
                        <small>{bannerSubtitle}</small>
                      </h5>
                    </div>
                    {this.state.playingButton ?
                      <a onClick={() => this.handleClickPlay(banner.id)}
                         className="default-home-banner-video-button"
                         style={{ display: (this.state.playingButton && this.state.mouseMoving) ? 'block' : this.state.playingButton ? 'none' : 'block'  }}
                      >
                      {isYoutube ?
                        <VolumeMute className="default-home-banner-video-icon"/>
                      :
                        <Pause className="default-home-banner-video-icon"/>
                      }
                      </a>
                      :
                      <a onClick={() => this.handleClickPlay(banner.id)}
                          className="default-home-banner-video-button"
                      >
                        <VolumeUp className="default-home-banner-video-icon"/>
                      </a>
                    }
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </React.Fragment>
    )
  }
}

export default withStyles(pagesStyle)(DefaultBanner);
